module.exports = __webpack_public_path__ + "img/MapThumb_FairFight.257725c5.webp";